import * as types from "./types";
import { get } from "@zendesk/knowledge-http-client";

const TAGS_URL = "/api/v2/tags.json";
const AUTOCOMPLETE_URL = "/api/v2/autocomplete/tags.json";

function fetchInitialTagsRequest() {
  return {
    type: types.FETCH_INITIAL_TAGS_REQUEST,
  };
}

function fetchInitialTagsSuccess(tags) {
  return {
    type: types.FETCH_INITIAL_TAGS_SUCCESS,
    tags,
  };
}

function fetchInitialTagsFailure(error) {
  return {
    type: types.FETCH_INITIAL_TAGS_FAILURE,
    error: true,
    payload: error,
  };
}

export function fetchInitial() {
  return dispatch => {
    dispatch(fetchInitialTagsRequest());

    return get(TAGS_URL)
      .then(({ tags }) => dispatch(fetchInitialTagsSuccess(tags)))
      .catch(err => {
        dispatch(fetchInitialTagsFailure(err));
      });
  };
}

function fetchAutocompleteTagsRequest(query) {
  return {
    type: types.FETCH_AUTOCOMPLETE_TAGS_REQUEST,
    query,
  };
}

function fetchAutocompleteTagsSuccess(query, tags) {
  return {
    type: types.FETCH_AUTOCOMPLETE_TAGS_SUCCESS,
    query,
    tags,
  };
}

function fetchAutocompleteTagsFailure(error, query) {
  return {
    type: types.FETCH_AUTOCOMPLETE_TAGS_FAILURE,
    error: true,
    payload: error,
    query,
  };
}

export function fetchAutocomplete(query) {
  return dispatch => {
    dispatch(fetchAutocompleteTagsRequest(query));

    return get(`${AUTOCOMPLETE_URL}?name=${query}`)
      .then(({ tags }) => dispatch(fetchAutocompleteTagsSuccess(query, tags)))
      .catch(err => {
        dispatch(fetchAutocompleteTagsFailure(err, query));
      });
  };
}



// WEBPACK FOOTER //
// ./src/actions/tags/index.js